module.exports = __webpack_public_path__ + "img/bgi.9ff7b628.jpg";